var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

/**
 *
 * @constructor
 * @param {RPC}rpc - 通过rpc生成Transaction模块
 */
var Transaction =
/*#__PURE__*/
function () {
  "use strict";

  function Transaction(iost) {
    _classCallCheck(this, Transaction);

    this._provider = iost.getProvider();
  }
  /**
   * 发送交易
   * @param {Tx}tx
   * @returns {promise}
   */


  _createClass(Transaction, [{
    key: "sendTx",
    value: function sendTx(tx) {
      var api = 'sendTx';
      return this._provider.send('post', api, JSON.parse(JSON.stringify(tx)));
    }
    /**
     * 通过交易哈希查询交易
     * @param {string}hash - base58编码的hash
     * @returns {promise}
     */

  }, {
    key: "getTxByHash",
    value: function getTxByHash(hash) {
      var api = 'getTxByHash/' + hash;
      return this._provider.send('get', api);
    }
    /**
     * 通过receipt哈希查询交易结果
     * @param {string}hash - base58编码的hash
     * @returns {promise}
     */

  }, {
    key: "getTxReceiptByHash",
    value: function getTxReceiptByHash(hash) {
      var api = 'getTxReceiptByHash/' + hash;
      return this._provider.send('get', api);
    }
    /**
     * 通过交易哈希查询交易结果
     * @param {string}txHash - base58编码的hash
     * @returns {promise}
     */

  }, {
    key: "getTxReceiptByTxHash",
    value: function getTxReceiptByTxHash(txHash) {
      var api = 'getTxReceiptByTxHash/' + txHash;
      return this._provider.send('get', api);
    }
  }]);

  return Transaction;
}();

module.exports = Transaction;